// assets/read-more.js
document.addEventListener('DOMContentLoaded', function() {
  var descBlock   = document.getElementById('product-description-block');
  if (!descBlock) return;

  var readMoreBtn = descBlock.querySelector('.read-more-btn');
  var container   = descBlock.querySelector('.paragraph-container');
  var expanded    = false;

  function isMobile() {
    return window.innerWidth < 750;
  }

  function checkIfOverflow() {
    // If we're already expanded, always show the button
    if (expanded) {
      readMoreBtn.style.display = '';
      return;
    }
    // Otherwise only show if content truly overflows collapsed height
    readMoreBtn.style.display =
      (container.scrollHeight > container.clientHeight)
        ? ''
        : 'none';
  }

  // Run on initial DOM ready
  checkIfOverflow();

  // Also run after everything (images/fonts) is loaded
  window.addEventListener('load', checkIfOverflow);

  // Recompute on real orientation changes only
  window.addEventListener('orientationchange', checkIfOverflow);

  // (Optional) guard against late-loading fonts/images
  setTimeout(checkIfOverflow, 500);

  readMoreBtn.addEventListener('click', function() {
    expanded = !expanded;
    descBlock.classList.toggle('collapsed', !expanded);
    descBlock.classList.toggle('expanded', expanded);
    readMoreBtn.setAttribute('aria-expanded', expanded);
    readMoreBtn.textContent = expanded
      ? 'Citește mai puțin -'
      : 'Citește mai mult +';

    // On mobile, when collapsing, scroll back into view
    if (!expanded && isMobile()) {
      setTimeout(function() {
        descBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  });
});
